import GroupedPublishersTable from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedPublishersTable'
import React, { useContext, useRef, useState } from 'react'
import AmendSharesOptions from '@Components/OverclaimView/DisputeOptionSection/AmendSharesOptions'
import DisputeOptionSection from '@Components/OverclaimView/DisputeOptionSection'
import { StoresContext } from '@App/contexts'
import ModalPortal from '@Components/Popups/ModalPortal'
import DisputeEmailForm from '@Components/OverclaimView/DisputeEmailForm'
import scrollToRef from '@App/helpers/scroll-to-ref'
import { observer } from 'mobx-react'
import { isActionableOverclaimHelper } from '@App/helpers/is-overclaim-helper'

interface OverclaimDetailTabProps {
    onAmend(): Promise<void>
    onClickUploadDocumentsOption: () => void
}

const OverclaimDetailTab = ({ onAmend, onClickUploadDocumentsOption }: OverclaimDetailTabProps) => {
    const [amendingShare, setAmendingShares] = useState(false)
    const [arePublishersValid, setArePublishersValid] = useState(true)
    const [emailFormIsOpen, setEmailFormIsOpen] = useState(false)

    const scrollRef = useRef(null)

    const { overclaimViewStore } = useContext(StoresContext)

    return (
        <div id="detail-tab">
            <GroupedPublishersTable
                allowShareEditing={amendingShare}
                onValidation={(isValid: boolean) => setArePublishersValid(isValid)}
                ref={scrollRef}
            />
            {isActionableOverclaimHelper(overclaimViewStore.overclaimViewItem) &&
                (amendingShare ? (
                    <AmendSharesOptions
                        onCancelAmendOption={() => setAmendingShares(false)}
                        onConfirmAmendOption={() => onAmend()}
                        disabled={!arePublishersValid}
                    />
                ) : (
                    <DisputeOptionSection
                        onClickEmailOption={() => setEmailFormIsOpen(!emailFormIsOpen)}
                        isExistingRelinquishment={overclaimViewStore.isExistingRelinquishment}
                        onClickAmendOption={() => {
                            if (scrollRef.current) {
                                scrollToRef(scrollRef)
                            }
                            setAmendingShares(true)
                        }}
                        onClickUploadDocumentsOption={() => onClickUploadDocumentsOption()}
                    />
                ))}
            <ModalPortal isOpen={emailFormIsOpen}>
                {emailFormIsOpen && (
                    <DisputeEmailForm
                        onClose={() => {
                            setEmailFormIsOpen(false)
                        }}
                    />
                )}
            </ModalPortal>
        </div>
    )
}
export default observer(OverclaimDetailTab)
